import { makeActions, makeAsyncFetchActions } from './utils';

const areas = makeActions({
  prefix: 'areas',
  types : [...makeAsyncFetchActions('fetch')],
});

const companies = makeActions({
  prefix: 'companies',
  types : [...makeAsyncFetchActions('fetch')],
});

const modal = makeActions({
  prefix: 'modal',
  types : ['open', 'close'],
});

const order = makeActions({
  prefix: 'order',
  types : [
    ...makeAsyncFetchActions('fetch'),
    ...makeAsyncFetchActions('update'),
    ...makeAsyncFetchActions('confirm'),
    ...makeAsyncFetchActions('events'),
    'reset events',
  ],
});

const orders = makeActions({
  prefix: 'orders',
  types : [...makeAsyncFetchActions('fetch'), 'set filters'],
});

const pois = makeActions({
  prefix: 'pois',
  types : [...makeAsyncFetchActions('fetch')],
});

const newuser = makeActions({
  prefix: 'newuser',
  types : [
    ...makeAsyncFetchActions('fetch'),
    ...makeAsyncFetchActions('update'),
    ...makeAsyncFetchActions('create'),
    ...makeAsyncFetchActions('remove'),
  ],
});

export default {
  areas,
  companies,
  modal,
  order,
  orders,
  pois,
  newuser,
};
